/**
 * Validate form fields
 *
 * @param {string} targetForm - selector for form to validate
 * @param {string} errorClass - class name applied if form group has errors
 */

import $ from 'jquery';

export const validateForm = (
    targetForm = '#ghwp-contactform',
    errorClass = 'ghwp-has-errors'
) => {
    // Get the fields we need to check
    // NOTE: this only tests required fields, but that works here
    const checkFields = $(targetForm)
        .find('input, textarea, select')
        .filter('[required]');

    // Event listeners for single fields
    checkFields.each(function() {
        var $el = $(this);
        const checkField = document.getElementById($el.attr('id'));

        checkField.addEventListener('input', function() {
            checkValidity($el);
        });

        checkField.addEventListener('focus', function() {
            checkValidity($el);
        });

        checkField.addEventListener('blur', function() {
            checkValidity($el);
        });
    });

    // Event listeners for form
    $(targetForm).submit(function(e) {
        checkFields.each(function() {
            checkValidity($(this));
        });

        // Don't submit form if it has errors
        if ($(targetForm).find(`.${errorClass}`).length > 0) {
            e.preventDefault();
        }
    });

    // Check if a field is valid
    function checkValidity(input) {
        const field = document.getElementById(input.attr('id'));
        const $formGroup = input.parent();
        const $msg = $formGroup.find('.ghwp-message');

        if (field.validity.valid) {
            $formGroup.removeClass(errorClass);
            $msg.text('');
        } else {
            $formGroup.addClass(errorClass);
            $msg.text(getErrorMessage(field));
        }
    }

    function getErrorMessage(field) {
        if (field.validity.valueMissing) {
            // Required field is empty
            return 'Bitte füllen Sie dieses Pflichtfeld aus.';
        } else if (field.validity.typeMismatch) {
            // Value is invalid
            return 'Bitte prüfen Sie Ihre Eingabe.';
        }
        return;
    }
};
